var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"row justify-content-between"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"playnow-menu"})])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }